<section id="portfolio" class="section section-gradient-2 portfolio-section">
  <div class="container">
    <h2 class="section-title">Products &amp; Portfolio</h2>
    <p class="section-subtitle">
      Discover our cutting-edge IP-PBX systems, VoIP phones, and data gateways
      designed for enterprise scaling.
    </p>

    <div class="portfolio-grid">
      @if (parentCategories.length === 0) {
        <div class="no-data-fallback">No data found.</div>
      }

      @for (product of visibleCategories; track product.id; let i = $index) {
        <div
          class="glass-card product-card reveal"
          [ngClass]="'delay-' + ((i % 3) + 1) * 100"
        >
          <div class="product-image-wrapper">
            <img
              [src]="product.image"
              [alt]="product.title"
              class="product-image"
              loading="lazy"
            />
            <div class="product-category-tag">{{ product.title }}</div>
          </div>

          <div class="product-content">
            <h3 class="product-title">{{ product.title }}</h3>
            <p class="product-desc">{{ product.description }}</p>

            @if (hasChildren(product)) {
              <button class="btn-view product-btn" (click)="openModal(product)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="15"
                  height="15"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
                View
                <!-- <span class="badge">{{ product.children.length }}</span> -->
              </button>
            }
          </div>
        </div>
      }
    </div>

    @if (hasMore) {
      <div class="show-more-wrapper">
        <button class="show-more-btn" (click)="toggleShowAll()">
          @if (!showAll) {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          } @else {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <polyline points="18 15 12 9 6 15"></polyline>
            </svg>
          }
          {{ showAll ? "Show Less" : "Show More" }}
        </button>
      </div>
    }
  </div>
</section>

<!-- ===== Children Modal ===== -->
@if (activeModal) {
  <div
    class="modal-backdrop"
    (click)="onBackdropClick($event)"
    role="dialog"
    aria-modal="true"
    [attr.aria-label]="'Sub-categories of ' + activeModal.title"
  >
    <div class="modal-box">
      <!-- Header -->
      <div class="modal-header">
        <div class="modal-header-info">
          <img
            [src]="activeModal.image"
            [alt]="activeModal.title"
            class="modal-parent-thumb"
          />
          <div>
            <p class="modal-label">Sub-categories</p>
            <h3 class="modal-title">{{ activeModal.title }}</h3>
          </div>
        </div>
        <button
          class="modal-close-btn"
          (click)="closeModal()"
          aria-label="Close modal"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>

      <!-- Children Grid -->
      <div class="modal-body">
        <div class="children-grid">
          @for (child of activeModal.children; track child.id) {
            <div class="child-card">
              <div class="child-image-wrapper">
                <img
                  [src]="child.image"
                  [alt]="child.title"
                  class="child-image"
                  loading="lazy"
                />
              </div>
              <div class="child-info">
                <span class="child-title">{{ child.title }}</span>
                @if (child.description) {
                  <span class="child-desc">{{ child.description }}</span>
                }
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}
